var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  gradientUnits: "userSpaceOnUse",
  x1: 123.076,
  x2: 423.439,
  y1: 141.739,
  y2: 442.102
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1d1d1b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.369,
  stopColor: "#1d1d1b",
  stopOpacity: 0.856
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#1d1d1b",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1d1d1b",
  stopOpacity: 0
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#5c6bc0",
  r: 250
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m505.965 258.78-101.4-101.4c-44.316-31.8-85.61-33.122-93.5-33.287l-5.035 4.779 16.5 16.5a307.083 307.083 0 0 0 -66.53-8.161 306.374 306.374 0 0 0 -38.908 2.971l-.051.008-16.1-16.1c-7.889.165-49.184 1.483-93.5 33.287 0 0-49.52 83.052-49.52 185.054l161.384 160.881a251.993 251.993 0 0 0 36.695 2.688c137.141 0 248.472-110.432 249.965-247.22z",
  fill: "url(#linear-gradient)",
  opacity: 0.49
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m404.561 157.376c-44.317-31.8-85.611-33.122-93.5-33.287l-5.036 4.779c56.57 15.819 83.932 40.537 83.932 40.537-48.557-23.451-94.315-31.698-133.957-32.194-39.641.5-85.4 8.743-133.956 32.194 0 0 27.362-24.718 83.933-40.537l-5.037-4.779c-7.889.165-49.184 1.483-93.5 33.287 0 0-49.52 83.052-49.52 185.054 1.678-1.977 30.719 43.833 105.587 45.481 0 0 12.59-14.007 21.654-26.366-43.645-12.359-60.095-37.076-60.095-37.076 45.374 28.057 87.755 38.852 130.934 37.449 43.179 1.4 85.56-9.392 130.934-37.449 0 0-16.45 24.717-60.1 37.076 9.065 12.359 21.655 26.366 21.655 26.366 74.867-1.648 103.908-47.458 105.586-45.481.005-102.002-49.514-185.054-49.514-185.054zm-209.5 153.086c-19.137 0-34.58-15.82-34.58-35.265s15.443-35.264 34.58-35.264v.165c18.969 0 34.58 15.82 34.58 35.264.004 19.28-15.441 35.1-34.576 35.1zm121.87 0c-19.137 0-34.58-15.82-34.58-35.1 0-19.444 15.611-35.264 34.58-35.264v-.165c19.137 0 34.58 15.82 34.58 35.264s-15.439 35.265-34.576 35.265z",
  fill: "#fff"
});

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.0659a5a02d6882b8254a0538bfce087a.svg";
export { ForwardRef as ReactComponent };